import { Injectable } from '@angular/core';
import { FirestoreHandlerService } from '../firestore/firestore-handler.service';
import { AnwLogsService } from '../Loggers/anw-logs.service';
import { BreadcrumbsService } from '../Breadcrumbs/breadcrumbs.service';
import { Season, Course, Run, Obstacle, FirestoreReference, Ninja, Split } from 'src/app/Classes/schema';
import { QueryFn } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class AnwService {
  bc: BreadcrumbsService;
  constructor(
    public fhs: FirestoreHandlerService,
    public logger: AnwLogsService
  ) {
    this.bc = new BreadcrumbsService(this.logger).init(this);
  }

  initSeasons() {
    return this.bc.getCollection("seasons").currentCollection();
  }

  initRuns() {
    return this.bc.getCollection("runs").currentCollection();
  }

  initCourses() {
    return this.bc.getCollection("courses").currentCollection();
  }

  initNinjas() {
    return this.bc.getCollection("ninjas").currentCollection();
  }

  initObstacles() {
    return this.bc.getCollection("obstacles").currentCollection();
  }

  initSeason() {
    return this.bc.getCollection("seasons").currentDoc();
  }

  initRun() {
    return this.bc.getCollection("runs").currentDoc();
  }

  initCourse() {
    return this.bc.getCollection("courses").currentDoc();
  }

  initNinja() {
    return this.bc.getCollection("ninjas").currentDoc();
  }

  initObstacle() {
    return this.bc.getCollection("obstacles").currentDoc();
  }

  getSeasons() {
    return this._genericGetCollection("seasons", "", "", "season", true);
  }

  getNinjas() {
    return this._genericGetCollection("ninjas");
  }

  getCourses(seasonId: string) {
    return this._genericGetCollection("courses", "seasonId", seasonId, "airDate", true);
  }

  getRuns(courseId: string) {
    return this._genericGetCollection("runs", "courseId", courseId, ['fellOn', 'totalTime'], [true, false]);
  }

  getObstacles(courseId: string) {
    return this._genericGetCollection("obstacles", "courseId", courseId, "position", false);
  }

  private _genericGetCollection(collectionId: string, queryArg?: string, queryVal?: any, orderArg?: string | string[], isDesc: boolean | boolean[] = true) {
    const cachedCollection = this.bc.getCollection(collectionId);
    if (cachedCollection) {
      this.log("---- found collection");

      cachedCollection.setColId(collectionId);
      cachedCollection.setQuery(queryArg, queryVal, orderArg, isDesc);

      const result = cachedCollection.collectionExport;
      return result;
    }
    this.log("---- did not return collection");
    return null;
  }

  getSeason(seasonId: any) {
    return this._genericGetDocument("seasons", seasonId);
  }

  getRun(runId: any) {
    return this._genericGetDocument("runs", runId);
  }

  getObstacle(obstacleId: any) {
    return this._genericGetDocument("obstacles", obstacleId);
  }

  getNinja(ninjaId: any) {
    return this._genericGetDocument("ninjas", ninjaId);
  }

  getCourse(courseId: any) {
    return this._genericGetDocument("courses", courseId);
  }

  // pingCollection(collectionId: any) {
  //   this.bc.getCollection(collectionId).pingCollection();
  // }

  private _genericGetDocument(collectionName: string, documentId: any) {
    const cachedCollection = this.bc.getCollection(collectionName);
    if (cachedCollection) {
      const result = cachedCollection.documentExport;
      cachedCollection.setdocumentId(String(documentId));
      return result;
    }
    this.log("---- did not return collection");
    return null;
  }


  // findRunId(ninjaId: string) {
  //   // const filterProject = (refs: FirestoreReference<Run>[]) => refs.find(ref => ref.data.ninjaId === ninjaId);
  //   this.getRuns().subscribe(refs => {
  //     console.log("Is there anybody out there?");
  //     return refs.find(ref => ref.data.ninjaId === ninjaId).id;
  //   })
  // }

  updateRun(run: Run, splits: Split[]) {
    splits.forEach(function (split) {
      const obstacleIndex = split.obstacleNumber - 1;
      while (run.aggregrateTimeSpent.length < split.obstacleNumber) {
        run.aggregrateTimeSpent.push(0);
        run.fallCounts.push(0);
        run.submissionsRecieved.push(0);
      }
      run.aggregrateTimeSpent[obstacleIndex] += split.timeSpent;
      run.fallCounts[obstacleIndex] += split.falls ? 1 : 0;
      run.submissionsRecieved[obstacleIndex] += 1
    });
    const fallSplit = splits.find(split => split.falls);
    if (!run.fellOn) {
      run.fellOn = fallSplit.obstacleNumber;
    } else if (run.fellOn != fallSplit.obstacleNumber) {
      run.fellOn = run.fallCounts[fallSplit.obstacleNumber - 1] > run.fallCounts[run.fellOn - 1] ? fallSplit.obstacleNumber : run.fellOn;
    }
    run.totalTime = run.aggregrateTimeSpent.reduce((totalTime, aggregateTime, obstacleIndex) => {
      if (obstacleIndex < run.fellOn - 1) {
        totalTime += aggregateTime / run.submissionsRecieved[obstacleIndex];
      }
      return totalTime;
    }, 0);
  }

  writeSplits(splits: Split[], runRef: FirestoreReference<Run>) {
    const run = runRef.data;
    this.log(splits);

    return this.fhs.batchWrite("splits", splits)
    .then(() => {
      run.flagForReview = true;
      return this.fhs.writeDoc('runs', run, runRef.id);
    }).then(() =>{
      this.updateRun(run, splits);
      return run;
    });
  }

  _filterProject<T>(idToSearchFor: string) {
    return (refs: FirestoreReference<T | any>[]) => refs.find(ref => ref.id === idToSearchFor);
  }

  log = this.logger.log;
}
